import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { dnAlert } from "./utils/dNews_Alert";
import logo_eagle from "./assets/img/logo_eagle.png";
import Select from "react-select";
import { checkboxMultiProps } from "./utils/MultiSelectCheckbox";
import { apiFetch } from "./utils/api";
import { useAccess } from "./utils/AccessContext";
import "./dSpr.css";
import "./Holiday.css";
import { FaSadCry } from "react-icons/fa";

// Holiday For dropdown - react-select with the orange-focus theme used by
// Generate Payslips. menuPortal lifts the list above the modal body.
const HOLIDAY_FOR_OPTIONS = [
    { value: "general",      label: "General" },
    { value: "department",   label: "Department" },
    { value: "job_position", label: "Job position" },
    { value: "location",     label: "Location" },
    { value: "employee",     label: "Employee" },
];
const HOLIDAY_SELECT_STYLES = {
    control: (p, s) => ({
        ...p,
        minHeight: 42,
        borderRadius: 10,
        borderColor: s.isFocused ? "#fb923c" : "#e2e8f0",
        boxShadow: s.isFocused ? "0 0 0 3px rgba(251, 146, 60, 0.15)" : "none",
        "&:hover": { borderColor: "#fb923c" },
    }),
    option: (p, s) => ({
        ...p,
        backgroundColor: s.isSelected ? "#4a90e2" : s.isFocused ? "#f3f4f6" : "#fff",
        color: s.isSelected ? "#fff" : "#0d1b2a",
        padding: "10px 12px",
        cursor: "pointer",
    }),
    menuPortal: base => ({ ...base, zIndex: 999999 }),
};

function Holiday({ navSize }) {
    // hasAccess reads the live Access Center matrix - no hardcoded role list.
    // Toggle "dTime > Holiday" in Access_level_configuration to control write
    // actions for any role (Admin / Sub Admin / Manager / User).
    const { hasAccess } = useAccess();
    const canManageHoliday = hasAccess("dTime", "Holiday");

    const [currentDate, setCurrentDate] = useState(new Date());
    const [calendarDays, setCalendarDays] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const [notes, setNotes] = useState({});
    const [holidayFor, setHolidayFor] = useState("");
    const [specificValue, setSpecificValue] = useState([]);
    const [holidayName, setHolidayName] = useState("");
    const [multiDay, setMultiDay] = useState(false);
    const [endDay, setEndDay] = useState("");
    const [holidayList, setHolidayList] = useState([]);
    const [employees, setEmployees] = useState([]);
    const navigate = useNavigate();

    const [departments, setDepartments] = useState([]);
    const [jobPositions, setJobPositions] = useState([]);

    const realYear = new Date().getFullYear();
    const minYear = realYear - 5;
    const maxYear = realYear + 5;

    const [showCalendarPopup, setShowCalendarPopup] = useState(false);
    const popupRef = React.useRef(null);
    const iconRef = React.useRef(null);
    const modalDateRef = useRef(null);

    const [multiHolidayModal, setMultiHolidayModal] = useState(false);
    const [selectedHolidayList, setSelectedHolidayList] = useState([]);
    const [openedFromMulti, setOpenedFromMulti] = useState(false);
    const [hideModal, setHideModal] = useState(false);
    const [existingHoliday, setExistingHoliday] = useState(false);
    const [selectedHoliday, setSelectedHoliday] = useState(null);
    const [loggedInEmp, setLoggedInEmp] = useState(null);

    useEffect(() => {
        fetchloginedEmployees();
        fetchEmployees();
        fetchHolidays();
        fetchDepartments();
        fetchJobPositions();
    }, [currentDate]);

    const fetchloginedEmployees = async () => {
        try {
            const res = await apiFetch(`/api/employee/logined_employee`, {
                method: 'GET',
                credentials: 'include',
            });
            const data = await res.json();
             
            if (data?.message === "Access Denied. No Token Provided!" ||
                data?.message === "Invalid Token") {
                navigate("/login");
                return;
            }

            if (data[0].emp_id) {
                setLoggedInEmp(data[0]);
                // Role redirect removed - ProtectedRoute (App.js) gates via matrix.
            }

        } catch (err) {
            console.error("Error fetching employees:", err);
        }
    };

    const fetchEmployees = async () => {
        try {
            const res = await apiFetch(`/api/employee/all`);
            const data = await res.json();
            setEmployees(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Error fetching employees:", err);
        }
    };

    const fetchDepartments = async () => {
        const res = await apiFetch("/api/Employee_configuration/get-department_config");
        const data = await res.json();
        setDepartments(Array.isArray(data) ? data : []);
    };

    const fetchJobPositions = async () => {
        const res = await apiFetch("/api/Employee_configuration/get-job_position_config");
        const data = await res.json();
        setJobPositions(Array.isArray(data) ? data : []);
    };

    const locations = ["Chennai", "Hyderabad", "Pune, Nagpur"];

    const fetchHolidays = async () => {
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();

        try {
            const res = await apiFetch(`/api/holiday/list?month=${month}&year=${year}`);
            const raw = await res.json();
            // Backend returns { error: "..." } on DB failure - guard so the
            // page doesn't crash with `data.forEach is not a function`.
            const data = Array.isArray(raw) ? raw : [];

            setHolidayList(data);

            const holidayMarks = {};
            const viewMonth = currentDate.getMonth();
            const viewYear  = currentDate.getFullYear();
            data.forEach(h => {
                const start = new Date(h.holiday_date);
                const end = h.holiday_end ? new Date(h.holiday_end) : start;

                let current = new Date(start);

                while (current <= end) {
                    // Only mark cells that actually belong to the displayed
                    // month/year. Without this, a June 30 - July 1 range
                    // wrongly painted June 1 because the bucket was keyed by
                    // day-of-month alone.
                    if (current.getMonth() === viewMonth && current.getFullYear() === viewYear) {
                        const day = current.getDate();
                        if (!holidayMarks[day]) {
                            holidayMarks[day] = [];
                        }
                        holidayMarks[day].push(h);
                    }
                    current.setDate(current.getDate() + 1);
                }
            });

            setNotes(holidayMarks);

        } catch (err) {
            console.error("❌ Fetch error:", err);
        }
    };

    const saveHoliday = async () => {
        // 🔴 Validate Holiday For
        if (!holidayFor) {
            dnAlert.warning("Required", "Please select Holiday For");
            return;
        }

        // 🔴 Validate Specific Dropdown except GENERAL
        if (holidayFor !== "general" && (!specificValue || specificValue.length === 0)) {
            dnAlert.warning("Required", `Please select a ${holidayFor.replace("_", " ")}`);
            return;
        }

        // 🔴 Validate Holiday Name
        if (!holidayName.trim()) {
            dnAlert.warning("Required", "Please enter Holiday Name");
            return;
        }

        // 🔴 Validate End Date if Multi Day
        if (multiDay && !endDay) {
            dnAlert.warning("Required", "Please select an End Date");
            return;
        }

        const start_date = `${currentDate.getFullYear()}-${String(
            currentDate.getMonth() + 1
        ).padStart(2, "0")}-${String(selectedDay).padStart(2, "0")}`;

        const end_date = multiDay ? endDay : start_date;

        let finalValue;

        if (holidayFor === "general") {
            finalValue = "All";
        }
        else if (holidayFor === "employee") {
            finalValue = Array.isArray(specificValue)
                ? specificValue.join(",")
                : specificValue;
        }
        else {
            // DEPARTMENT / JOB POSITION / LOCATION
            if (specificValue.includes("All")) {
                finalValue = "All";
            } else {
                finalValue = specificValue.join(",");
            }
        }

        const payload = {
            holiday_date: start_date,
            holiday_end: end_date,
            holiday_name: holidayName,
            holiday_for: holidayFor,
            holiday_value: finalValue,
        };
        if (!notes[selectedDay] && existingHoliday) return;

        try {
            const res = existingHoliday
                ? await apiFetch(`/api/holiday/update/${selectedHoliday.holiday_id}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                    credentials: 'include',
                })
                : await apiFetch("/api/holiday/save-holiday", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                    credentials: 'include',
                });

            const data = await res.json();

            if (data.success) {
                dnAlert.success("Holiday Saved", "The holiday has been added or updated successfully");
                fetchHolidays();
                setShowModal(false);
            } else {
                dnAlert.error("Save Failed", data.error || "Something went wrong");
            }

        } catch (err) {
            console.error("❌ Save error:", err);
            dnAlert.error("Error", "Failed to save holiday. Please try again.");
        }
    };

    const deleteMultiHoliday = async (id) => {
        const ok = await dnAlert.confirm({
            title: "Delete holiday?",
            message: "This holiday will be deleted.",
            confirmLabel: "Delete",
            danger: true,
        });
        if (!ok) return;
        const res = await apiFetch(`/api/holiday/delete/${id}`, {
            method: "DELETE",
            credentials: 'include',
        });
        const data = await res.json();
        if (data.success) {
            dnAlert.success("Deleted", "Holiday removed.");
            setMultiHolidayModal(false);
            fetchHolidays();
        }
    };

    const deleteHoliday = async () => {
        if (!notes[selectedDay]) return;

        const ok = await dnAlert.confirm({
            title: "Delete holiday?",
            message: "This holiday will be permanently deleted.",
            confirmLabel: "Delete",
            danger: true,
        });
        if (!ok) return;
        try {
            const res = await apiFetch(`/api/holiday/delete/${selectedHoliday.holiday_id}`, {
                method: "DELETE",
                credentials: 'include',
            });
            const data = await res.json();
            if (data.success) {
                dnAlert.success("Deleted", "The holiday has been removed.");
                fetchHolidays();
                setShowModal(false);
            } else {
                dnAlert.error("Delete Failed", data.error || "Something went wrong");
            }
        } catch (err) {
            console.error("❌ Delete error:", err);
            dnAlert.error("Error", "Failed to delete holiday. Please try again.");
        }
    };

    const generateColorFromName = (name) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (let i = 0; i < 3; i++) {
            const value = (hash >> (i * 8)) & 0xFF;
            color += ('00' + value.toString(16)).substr(-2);
        }
        return color;
    };

    const normalizeDate = (dateString) => {
        if (!dateString) return "";
        return dateString.split("T")[0]; // Keeps only yyyy-MM-dd
    };

    const handleDayClick = (day) => {
        if (!day) return;
        setSelectedDay(day);

        const list = notes[day];   // list of holidays for day

        if (list) {
            setSelectedHolidayList(list);
            setMultiHolidayModal(true);
            return;
        } else {
            setHolidayName("");
            setHolidayFor("");
            setSpecificValue([]);
            setMultiDay(false);
            setEndDay("");
            setExistingHoliday(false);
            setSelectedHoliday(null);
            if (canManageHoliday) {
                setShowModal(true);
            }
        }
    };

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    useEffect(() => {
        generateCalendar();
    }, [currentDate, notes]);

    const generateCalendar = () => {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();

        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        const tempDays = [];
        for (let i = 0; i < firstDay; i++) {
            tempDays.push("");
        }
        for (let d = 1; d <= daysInMonth; d++) {
            tempDays.push(d);
        }

        setCalendarDays(tempDays);
    };

    const prevMonth = () => {
        const y = currentDate.getFullYear();
        const m = currentDate.getMonth();

        // Block going below minYear January
        if (y === minYear && m === 0) return;

        setCurrentDate(new Date(y, m - 1, 1));
    };

    const nextMonth = () => {
        const y = currentDate.getFullYear();
        const m = currentDate.getMonth();

        // Block going above maxYear December
        if (y === maxYear && m === 11) return;

        setCurrentDate(new Date(y, m + 1, 1));
    };

    const buildOptions = () => {
        if (holidayFor === "department") {
            return [
                { value: "All", label: "All" },
                ...departments.map(dep => ({
                    value: dep.department_id,
                    label: dep.department_name
                }))
            ];
        }

        if (holidayFor === "job_position") {
            return [
                { value: "All", label: "All" },
                ...jobPositions.map(job => ({
                    value: job.job_id,
                    label: job.job_name
                }))
            ];
        }

        if (holidayFor === "location") {
            return [
                { value: "All", label: "All" },
                ...locations.map(loc => ({
                    value: loc,
                    label: loc
                }))
            ];
        }

        if (holidayFor === "employee") {
            return employees.map(emp => ({
                value: emp.emp_id,
                label: `${emp.emp_first_name} ${emp.emp_last_name} (${emp.emp_id})`
            }));
        }

        return [];
    };

    // Human-readable "who this holiday applies to" for the day-detail modal.
    // holiday_value stores ids (department / job_position), emp_ids (employee)
    // or location names — resolve ids back to names using the loaded lists.
    const SCOPE_LABEL = {
        general: "General", department: "Department", job_position: "Job position",
        location: "Location", employee: "Employee",
    };
    const describeHolidayScope = (h) => {
        const forRaw = String(h.holiday_for || "").toLowerCase();
        if (!forRaw || forRaw === "general") return "General - All Staffs";

        const label = SCOPE_LABEL[forRaw] || forRaw;
        const vals = h.holiday_value === "All"
            ? ["All"]
            : String(h.holiday_value || "").split(",").map(v => v.trim()).filter(Boolean);
        if (vals.length === 0) return label;
        if (vals.includes("All")) return `${label} · All`;

        let names = vals;
        if (forRaw === "department") {
            names = vals.map(v => (departments.find(d => String(d.department_id) === String(v)) || {}).department_name || v);
        } else if (forRaw === "job_position") {
            names = vals.map(v => (jobPositions.find(j => String(j.job_id) === String(v)) || {}).job_name || v);
        } else if (forRaw === "employee") {
            names = vals.map(v => {
                const e = employees.find(x => String(x.emp_id) === String(v));
                return e ? `${e.emp_first_name} ${e.emp_last_name} (${e.emp_id})` : v;
            });
        } // location values are already names
        return `${label}: ${names.join(", ")}`;
    };

    const closeShowModal = () => {
        if (openedFromMulti) {
            setHideModal(true);            // hide content
            setShowModal(false);           // close current modal

            setTimeout(() => {
                setMultiHolidayModal(true); // reopen list modal smoothly
                setHideModal(false);        // reset hide state
            }, 30); // minimal delay, no animation flicker

            setOpenedFromMulti(false);
        } else {
            setExistingHoliday(false); // reset existing holiday
            setShowModal(false);
        }
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                popupRef.current &&
                !popupRef.current.contains(event.target) &&
                iconRef.current &&
                !iconRef.current.contains(event.target)
            ) {
                setShowCalendarPopup(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="holiday-container">
            <div className={`holiday-dashboard ${navSize}`}>
                <div className="dspr-header-wrapper">
                    <h2>
                        <a className="navbar-brand" href="#">
                            <img
                                src={logo_eagle}
                                alt="dAdmin Logo"
                                style={{
                                    height: "50px",
                                    objectFit: "contain",
                                    marginLeft: "-20px",
                                }}
                            />
                        </a>
                        Holiday Calendar
                    </h2>
                    <p className="dspr-subtitle">Plan company-wide and segment-specific holidays. Click a date to add or edit; multi-day ranges supported.</p>
                </div>

                <div className={`holiday-dashboard-content`}>
                    <div style={{ marginLeft: "95%", color: "#2C3E50" }}>
                        {/* Calendar icon for date picker */}
                        <i
                            ref={iconRef}
                            className="fa-solid fa-calendar-days"
                            style={{ cursor: "pointer", fontSize: "22px", marginLeft: "10px" }}
                            onClick={() => setShowCalendarPopup(!showCalendarPopup)}
                        ></i>
                        {showCalendarPopup && (
                            <div className="calendar-popup-box" ref={popupRef}>
                                <h5 className="mb-2">Select Month & Year</h5>

                                {/* Month Dropdown */}
                                <select
                                    className="form-select mb-2"
                                    value={currentDate.getMonth()}
                                    onChange={(e) => {
                                        const newMonth = Number(e.target.value);
                                        setCurrentDate(new Date(currentDate.getFullYear(), newMonth, 1));
                                    }}
                                >
                                    {monthNames.map((m, index) => (
                                        <option key={index} value={index}>{m}</option>
                                    ))}
                                </select>

                                {/* Year Dropdown */}
                                <select
                                    className="form-select mb-2"
                                    value={currentDate.getFullYear()}
                                    onChange={(e) => {
                                        const newYear = Number(e.target.value);
                                        setCurrentDate(new Date(newYear, currentDate.getMonth(), 1));
                                    }}
                                >
                                    {Array.from({ length: 10 }).map((_, i) => (
                                        <option key={i} value={minYear + i}>
                                            {minYear + i}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                    </div>
                    <div className="calendar">
                        <div className="calendar-header">

                            {/* Hide Prev only if we are at minYear January */}
                            {!(currentDate.getFullYear() === minYear && currentDate.getMonth() === 0) && (
                                <button className="month-btn" onClick={prevMonth}>Prev</button>
                            )}

                            <div className="month-title">
                                {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
                            </div>

                            {/* Hide Next only if we are at maxYear December */}
                            {!(currentDate.getFullYear() === maxYear && currentDate.getMonth() === 11) && (
                                <button className="month-btn" onClick={nextMonth}>Next</button>
                            )}
                        </div>

                        <table className="calendar-table">
                            <thead>
                                <tr>
                                    <th>Sun</th><th>Mon</th><th>Tue</th>
                                    <th>Wed</th><th>Thu</th><th>Fri</th><th>Sat</th>
                                </tr>
                            </thead>

                            <tbody>
                                {Array.from({ length: Math.ceil(calendarDays.length / 7) }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {calendarDays.slice(rowIndex * 7, rowIndex * 7 + 7).map((day, i) => (
                                            <td
                                                key={i}
                                                className={day && notes[day] ? "holiday-day" : ""}
                                                onClick={() => handleDayClick(day)}
                                            >
                                                {day}
                                                {day && notes[day] && (
                                                    <div
                                                        className="holiday-list"
                                                        title={notes[day].map(h => h.holiday_name).join(", ")} // show on hover
                                                    >
                                                        {notes[day].slice(0, 2).map((h, idx) => (
                                                            <div
                                                                key={idx}
                                                                className="holiday-chip"
                                                                style={{ backgroundColor: generateColorFromName(h.holiday_name) }}
                                                            >
                                                                {h.holiday_name}
                                                            </div>
                                                        ))}

                                                        {notes[day].length > 2 && (
                                                            <div className="holiday-chip more-chip">
                                                                +{notes[day].length - 2} more
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {multiHolidayModal && (
                        <div className="multi-modal-overlay">
                            <div className="multi-modal-content" onClick={(e) => e.stopPropagation()}>
                                <h3>Holidays on {selectedDay} {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}</h3>

                                <div
                                    className="holiday-close-icon multi-close-icon"
                                    onClick={() => {
                                        setExistingHoliday(false); // reset existing holiday
                                        setMultiHolidayModal(false);
                                    }}
                                    title="Close"
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </div>

                                <div className="multi-modal-body">

                                {/* Access Center matrix controls write actions dynamically. */}
                                {canManageHoliday && (
                                    <div style={{ textAlign: "center" }}>
                                        <button
                                            className="multi-add-btn"
                                            onClick={() => {
                                                setMultiHolidayModal(false);
                                                setHolidayName("");
                                                setHolidayFor("");
                                                setSpecificValue([]);
                                                setMultiDay(false);
                                                setEndDay("");

                                                // Adding a NEW holiday - clear any
                                                // leftover "edit" state so save inserts
                                                // instead of overwriting an existing one.
                                                setExistingHoliday(false);
                                                setSelectedHoliday(null);

                                                setOpenedFromMulti(true);
                                                setShowModal(true);
                                            }}
                                        >
                                            + Add Holiday
                                        </button>
                                    </div>
                                )}

                                {selectedHolidayList.map((h, i) => (
                                    <div key={i} className="multi-holiday-row">
                                        <div className="multi-holiday-info">
                                            <span className="multi-holiday-name">{h.holiday_name}</span>
                                            <span className="multi-holiday-scope">{describeHolidayScope(h)}</span>
                                        </div>
                                        {/* Edit / Delete follow the same Access Center flag */}
                                        {canManageHoliday && (
                                            <div className="multi-holiday-buttons">
                                                <button
                                                    className="multi-edit-btn"
                                                    onClick={() => {
                                                        setHolidayName(h.holiday_name);
                                                        setHolidayFor(h.holiday_for);
                                                        setSpecificValue(h.holiday_value === "All"
                                                            ? ["All"]
                                                            : h.holiday_value?.split(",") || []
                                                        );
                                                        const start = normalizeDate(h.holiday_date);
                                                        const end = normalizeDate(h.holiday_end);

                                                        setMultiDay(end && end !== start);
                                                        setEndDay(end && end !== start ? end : "");
                                                        setSelectedHoliday(h);
                                                        setExistingHoliday(true);  // set existing holiday
                                                        setOpenedFromMulti(true);     // <-- IMPORTANT FLAG
                                                        setMultiHolidayModal(false);
                                                        setShowModal(true);
                                                    }}
                                                >
                                                    Edit
                                                </button>

                                                <button
                                                    className="multi-delete-btn"
                                                    onClick={(e) => deleteMultiHoliday(h.holiday_id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Holiday entry Modal */}
                    {showModal && (
                        <div className="holiday-modal-overlay"
                            style={{ opacity: hideModal ? 0 : 1, transition: "opacity .15s ease" }}
                        >
                            <div
                                className="holiday-modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* Close icon */}
                                <div
                                    className="holiday-close-icon"
                                    onClick={closeShowModal}
                                    title="Close"
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </div>

                                {/* Modal Title */}
                                <h3 className="holiday-modal-title" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    {selectedDay} {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}

                                    {/* Calendar Icon */}
                                    <i
                                        className="fa-solid fa-calendar-days"
                                        style={{ cursor: "pointer", fontSize: "20px" }}
                                        onClick={() => modalDateRef.current.showPicker()}
                                    ></i>

                                    <input
                                        type="date"
                                        ref={modalDateRef}
                                        min={`${realYear}-01-01`}
                                        max={`${maxYear}-12-31`}
                                        style={{
                                            position: "absolute",
                                            opacity: 0,
                                            pointerEvents: "none",
                                            left: "30%",
                                            top: "15%",
                                            height: "1px",
                                            width: "1px"
                                        }}
                                        onChange={(e) => {
                                            const d = new Date(e.target.value);
                                            setSelectedDay(d.getDate());
                                            setCurrentDate(d);
                                        }}
                                    />

                                </h3>

                                <div className="holiday-modal-body">
                                    {/* Holiday For */}
                                    <label className="form-label">Holiday For</label>
                                    <Select
                                        options={HOLIDAY_FOR_OPTIONS}
                                        value={HOLIDAY_FOR_OPTIONS.find(o => o.value === holidayFor) || null}
                                        onChange={(opt) => {
                                            const value = opt ? opt.value : "";
                                            setHolidayFor(value);

                                            // RESET values
                                            setSpecificValue([]);
                                            setHolidayName("");

                                            // Start each new selection with multi-day off;
                                            // the user can enable it for any type, incl. employee.
                                            setMultiDay(false);
                                            setEndDay("");

                                            if (value === "employee") {
                                                setHolidayName("Birthday Celebration");
                                            }
                                        }}
                                        isSearchable={false}
                                        placeholder="Select"
                                        menuPortalTarget={document.body}
                                        styles={HOLIDAY_SELECT_STYLES}
                                    />

                                    {holidayFor && holidayFor !== "general" && (
                                        <>
                                            <label className="form-label mt-3">
                                                Select {holidayFor.replace("_", " ")}
                                            </label>

                                            <Select
                                                isMulti
                                                {...checkboxMultiProps}
                                                menuPortalTarget={document.body}
                                                styles={HOLIDAY_SELECT_STYLES}
                                                options={buildOptions()}
                                                value={buildOptions().filter(opt => specificValue.includes(String(opt.value)))}
                                                onChange={(selected) => {
                                                    const values = selected ? selected.map(s => String(s.value)) : [];
                                                    // "All" is exclusive: picking it clears the others,
                                                    // and picking any other option while "All" is in clears "All".
                                                    let next;
                                                    if (values.includes("All") && !specificValue.includes("All")) {
                                                        next = ["All"];
                                                    } else if (values.includes("All") && values.length > 1) {
                                                        next = values.filter(v => v !== "All");
                                                    } else {
                                                        next = values;
                                                    }
                                                    setSpecificValue(next);
                                                }}
                                            />
                                        </>
                                    )}

                                    {/* Holiday Name */}
                                    <label className="form-label mt-3">Holiday Name</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={holidayName}
                                        onChange={(e) => setHolidayName(e.target.value)}
                                        placeholder="Enter holiday name"
                                    />

                                    {/* Apply Multiple Days - whole label clickable */}
                                    {holidayFor && (
                                        <div className="mt-3">
                                            <label style={{ cursor: "pointer", userSelect: "none" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={multiDay}
                                                    onChange={() => setMultiDay(!multiDay)}
                                                />
                                                <span className="ms-2">Apply holiday for multiple days</span>
                                            </label>
                                        </div>
                                    )}

                                    {/* End Date */}
                                    {multiDay && (
                                        <>
                                            <label className="form-label mt-2">End Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={endDay}
                                                min={`${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}-${String(selectedDay).padStart(2, "0")}`}
                                                onClick={(e) => {
                                                    // ✅ open calendar manually (only if supported)
                                                    if (typeof e.target.showPicker === "function") {
                                                        e.target.showPicker();
                                                    }
                                                }}
                                                onChange={(e) => setEndDay(e.target.value)}
                                            />
                                        </>
                                    )}
                                </div>
                                {/* Action Buttons */}
                                <div className="holiday-modal-actions">
                                    {notes[selectedDay] && (
                                        <button className="holiday-delete-btn" onClick={deleteHoliday}>
                                            Delete
                                        </button>
                                    )}
                                    <button className="holiday-save-btn" onClick={saveHoliday}>Save</button>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}

export default Holiday;
